// removed by extract-text-webpack-plugin
module.exports = {"Grid":"_1zACjP8zZJiFiw1TljRkLx","row":"_3lOEIl3C5hzcf2CwJNHq78","cell":"_21eKr11DF3Vs5G5_skG-U1"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Grid/Grid.scss
 ** module id = 390
 ** module chunks = 1
 **/